import {
    APP_TAB_CHANGE,
    APP_HISTORY_CHANGE,
} from './app.actions';

const initialState = 'profiles';

/**
 * Application reducers
 * Handles tab change and history state change
 *
 * @param {string} state
 * @param {{}} action
 * @returns {string}
 */
export default function app(state = initialState, action) {
    switch (action.type) {
    case APP_TAB_CHANGE:
        return action.tab;
    case APP_HISTORY_CHANGE:
        return action.payload.tab || initialState;
    default:
        return state;
    }
}



// WEBPACK FOOTER //
// ./src/js/App/app.reducer.js